import { axiosInstance } from '../api';

export default function(qrId, questionnaireResponse) {
    return axiosInstance.put(`/fhir/QuestionnaireResponse/${qrId}`, questionnaireResponse);
}